import React, { useState } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { HelperCore } from '@/common/dependencies';
import { SVGPureIcon } from '@/ui';
import { getMcpToolsConfig, McpToolsConfig } from '@shared/constants/mcp';
import CircleLoading from '@/components/ani/circle-loading';

const McpToolsQuery = observer((props) => {
  const {
    className = '',
    event,
    mcpStore,
    messageItem,
  } = props;

  const config = getMcpToolsConfig(event);
  if(config.hidden){
    return null;
  }

  return (
    <div 
      className={`px-10px w-full flex flex-col bg-black bg-opacity-3 hover:bg-opacity-6 rounded-12px ${className}`}
      data-id={event?.planStepId}
      >
      <div className="flex w-full h-32px items-center">
        <SVGPureIcon name={`${config.getIcon ? config.getIcon(event) : config.icon}`} className='size-18px mr-3px flex-shrink-0' />
        <div className="text-13px text-black leading-18px flex items-center flex-shrink max-w-9/10">
          <div className="mcp-mobile-hidden flex-shrink-0">本轮搜索关键词：</div>
          <div className="font-bold text-black text-opacity-50 flex-shrink truncate flex items-center">
            {
              event?.text?.split(' ').filter(item => item && !/^本轮搜索关键词/.test(item)).map(item => {
                return (
                  <>
                    <div>{item}</div>
                    <div className='min-w-1px w-1px h-10px inline-block bg-black bg-opacity-10 mx-6px'></div>
                  </>
                )
              })
            }
          </div>
        </div>
      </div>
    </div>
  )
});
export default McpToolsQuery;